// extracted by mini-css-extract-plugin
export default {"component":"V1V9f8","icon":"LP67rd","title":"jj60BG"};